import { forwardRef, useEffect, useState } from "react";
import CreatableSelect from "react-select/creatable";
import { IOption } from "Dashboard/domain/IOption";
import { partnersService } from "../services/partner.service";

const MunicipalitySelectCreate = forwardRef<any, any>((props, ref) => {
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState<IOption[]>([]);
  const { value, setValue } = props;
  const [inputValue, setInputValue] = useState<string | undefined>(undefined);

  useEffect(() => {
    async function getData() {
      const municipalities = await partnersService.getAllMunicipalities();
      const op = municipalities.map((municipality) => {
        return {
          label: municipality.name,
          value: municipality.municipalityId,
        };
      });
      setOptions(op);
      setIsLoading(false);
    }

    try {
      getData();
    } catch (err) {
      console.log(err);
    }
  }, []);

  const handleChange = (newValue: any, actionMeta: any) => {
    setValue(newValue);
    props.onChange(newValue ? newValue.value : null);
  };

  const createOption = async (name: string): Promise<IOption> => {
    try {
      const municipality = await partnersService.createMunicipality(name);
      return {
        label: municipality.name,
        value: municipality.municipalityId,
      };
    } catch (err) {
      throw err;
    }
  };

  const handleCreate = async (inputValue: any) => {
    try {
      setIsLoading(true);
      const newOption = await createOption(inputValue);
      setOptions([...options, newOption]);
      handleChange(newOption, null);
      setIsLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  const formatCreate = (inputValue: string) => {
    return <p> Dodaj: {inputValue}</p>;
  };

  return (
    <CreatableSelect
      styles={props.customStyles}
      menuPosition="fixed"
      ref={ref}
      isClearable
      className="municipality-select-container"
      classNamePrefix="municipality-select"
      placeholder=""
      formatCreateLabel={formatCreate}
      isDisabled={isLoading}
      isLoading={isLoading}
      onChange={handleChange}
      onCreateOption={handleCreate}
      inputValue={props.preserveInput && inputValue}
      onInputChange={props.preserveInput &&
        ((newVal) => setInputValue(newVal))}
      onMenuOpen={props.preserveInput &&
        (() => setInputValue(value?.label))}
      onMenuClose={props.preserveInput &&
        (() => setInputValue(undefined))}
      options={options}
      value={value}
      {...{ error: props.error }}
    />
  );
});

export default MunicipalitySelectCreate;
